export default [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/pages/Home.vue'),
    meta: { layout: 'app' }
  },

  {
    path: '/teste',
    name: 'teste',
    component: () => import('@/pages/Chat.vue'),
    meta: { layout: 'app', public: true }
  },

  {
    path: '/404',
    name: 'NaoEncontrado',
    component: () => import('@/pages/404.vue'),
    meta: { layout: 'full', public: true }
  },

  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/Login.vue'),
    meta: { layout: 'full', public: true }
  },

  {
    path: '/sistema/configuracoes',
    name: 'Configuracoes',
    component: () => import('@/pages/Configuracoes.vue'),
    meta: { layout: 'app', permissao: 'configuracoes_avancadas:acessar' }
  },

  {
    path: '/sistema/configuracoes2',
    name: 'ConfiguracoesSistema',
    // component: () => import('@/pages/Configuracoes.vue'),
    component: () => import('@/pages/sistema/configuracoes/ConfiguracoesSistema.vue'),
    meta: { layout: 'app', permissao: 'configuracoes:acessar' }
  },
  {
    path: '/sistema/whatsapp',
    name: 'Whatsapp',
    // component: () => import('@/pages/Configuracoes.vue'),
    component: () => import('@/pages/sistema/configuracoes/Whatsapp.vue'),
    meta: { layout: 'app', permissao: 'whatsapp:acessar' }
  },

]
